import React, { useEffect } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import SearchIcon from "@material-ui/icons/Search";
import InsertInvitationOutlinedIcon from "@material-ui/icons/InsertInvitationOutlined";
import GroupAddOutlinedIcon from "@material-ui/icons/GroupAddOutlined";

import { Card } from "react-bootstrap";
import MuiAlert from "@material-ui/lab/Alert";

import {
  TablePagination,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  makeStyles,
  Typography,
  InputBase,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Snackbar,
  CircularProgress,
  Box,
  DialogContentText
} from "@material-ui/core";
import { DeleteJobseeker } from "../apis";

const GET_CLIENTS_LIST = gql`
  query Query(
    $getJobSeekerListByCoachPageNo: Int
    $getJobSeekerListByCoachLimit: Int
    $getJobSeekerListByCoachSearchText: String
  ) {
    getJobSeekerListByCoach(
      pageNo: $getJobSeekerListByCoachPageNo
      limit: $getJobSeekerListByCoachLimit
      searchText: $getJobSeekerListByCoachSearchText
    ) {
      jobSeekerList {
        id
        firstName
        lastName
        email
        cellPhone
        userStageJsonString
      }
      jobSeekerCount
      pageNo
    }
  }
`;

// add client
const REGISTER_USER = gql`
  mutation Mutation(
    $addJobSeekerFirstName: String!
    $addJobSeekerLastName: String!
    $addJobSeekerEmail: String!
    $addJobSeekerPassword: String!
  ) {
    addJobSeeker(
      firstName: $addJobSeekerFirstName
      lastName: $addJobSeekerLastName
      email: $addJobSeekerEmail
      password: $addJobSeekerPassword
    ) {
      code
      success
      message
    }
  }
`;
const SEND_INVITATION = gql`
  mutation SendInvitationMutation(
    $sendInvitationEmail: String
    $sendInvitationFirstName: String
    $sendInvitationLastName: String
  ) {
    sendInvitation(
      email: $sendInvitationEmail
      firstName: $sendInvitationFirstName
      lastName: $sendInvitationLastName
    ) {
      code
      success
      message
    }
  }
`;

// css
const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
    background: "#ebf2f3",
    color: "#000",
    borderBottom: "3px solid #FFF",
    padding: "10px 16px",
    lineHeight: "40px",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "5px",
    align: "left",
    verticalAlign: "middle"
  },
  dropdown: {
    position: "absolute",
    top: 28,
    right: 0,
    left: 0,
    zIndex: 1,
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(1.5, 2),
    height: "100%",
    zIndex: "9",
    color: "#000000",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "14px",
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: "40px !important",
    // paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "50% !important",
    position: "absolute",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));
// end of css

const headers = ["Client Name", "Email", "Phone", "Stage", "Action"];

let rows = [];
let count;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export function ClientListTable({ setSelectedUser, refetchCount }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearchText] = React.useState("");
  const [DialogState, setDialogState] = React.useState(false);
  const [dialogStateForAddClient, setDialogStateForAddClient] = React.useState(
    false
  );

  const [clientInformation, setClientInformation] = React.useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
  });
  const { data, refetch } = useQuery(GET_CLIENTS_LIST, {
    variables: {
      getJobSeekerListByCoachPageNo: page,
      getJobSeekerListByCoachLimit: rowsPerPage,
      getJobSeekerListByCoachSearchText: search,
    },
  });

  React.useEffect(() => {
    if (refetchCount != 0) {
      refetch();
      // alert('called')
    }
    // alert('outer called');
    // alert('mounted');
  }, [refetchCount]);

  const [addClient, { loading: addClientLoading }] = useMutation(
    REGISTER_USER,
    {
      onCompleted(response) {
        if (response.addJobSeeker.code === "400") {
          setSnackBarText(response.addJobSeeker.message);
          setSnackbarSeverity("error");
          setSnackBarOpen(true);
        } else {
          setDialogStateForAddClient(false);
          setSnackbarSeverity("success");
          setSnackBarText("Client Added Successfully");
          setSnackBarOpen(true);
          refetch();
        }
      },
      onError(error){
        setSnackBarText('An error occurred, please try again or reach out to us');
        setSnackbarSeverity("error");
        setSnackBarOpen(true);
      }
    }
  );
  const [snackBarText, setSnackBarText] = React.useState("");
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  const [deleteId, setDeleteId] = React.useState("");

  const [sendInvitation, { loading: sendInvitationLoader }] = useMutation(
    SEND_INVITATION,
    {
      onCompleted(sendInvitation) {
        setDialogState(false);
        setSnackbarSeverity("success");
        setSnackBarOpen(true);
        setSnackBarText("Invitation sent Successfully");
        refetch();
      },
      onError(error){
        setSnackBarText('An error occurred, please try again or reach out to us');
        setSnackbarSeverity("error");
        setSnackBarOpen(true);
      }
    }
  );

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const searchText = (event) => {
    setSearchText(event.target.value);

    if (event.target.value.length > 2) {
      refetch();
    } else if (event.target.value.length === 0) refetch();
  };

  const handleSelectedUser = (id) => {
    setSelectedUser(id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    refetch();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDialogOpen = () => {
    setDialogState(true);
  };

  const handleDialogOpenForAddClient = () => {
    setDialogStateForAddClient(true);
  };
  const handleDialogClose = () => {
    setDialogState(false);
    setDialogStateForAddClient(false);
  };
  const classes = useStyles();

  if (typeof data === "object") {
    count = parseInt(data.getJobSeekerListByCoach.jobSeekerCount);
    rows = data.getJobSeekerListByCoach.jobSeekerList.map((key) => {
      // console.log(key, 'kesyes')
      // Stage
      let lastSelectedStage = "";
      if (key.userStageJsonString) {
        let stagesList = JSON.parse(key.userStageJsonString);
        Object.keys(stagesList).map((stages) => {
          if (typeof stagesList[stages] === "object") {
            Object.keys(stagesList[stages]).map((stage) => {
              if (stagesList[stages][stage]) {
                lastSelectedStage = stage;
              }
            });
          }
          if (typeof stagesList[stages] === "boolean") {
            if (stagesList[stages]) {
              lastSelectedStage = stages;
            } else {
              if (!lastSelectedStage.length)
                lastSelectedStage = "No stage selected";
            }
          }
        });
      } else {
        lastSelectedStage = "No stage selected";
      }
      let phone = "";
      if (key.cellPhone && key.cellPhone !== "0") {
        phone = key.cellPhone;
      }
      if (lastSelectedStage === "" || lastSelectedStage === "No stage selected") {
        lastSelectedStage = "N/A";
      }
      return {
        id: key.id,
        name: key.firstName + " " + key.lastName,
        email: key.email,
        phone: phone || "N/A",
        stage: lastSelectedStage,
      };
    });
  }
  const handleFirstName = (evt) => {
    setFirstName(evt.target.value);
  };
  const handleLastName = (evt) => {
    setLastName(evt.target.value);
  };
  const handleEmail = (evt) => {
    setEmail(evt.target.value);
  };


  const handleSendInvitation = () => {
    sendInvitation({
      variables: {
        sendInvitationEmail: email.toLowerCase(),
        sendInvitationFirstName: firstName,
        sendInvitationLastName: lastName,
      },
    });
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  const handleDeleteJobseeker = async (id) => {
    setDeleteId(id);
    try{
      let res = await DeleteJobseeker(id);
      refetch();
      setSnackbarSeverity("success");
      setSnackBarOpen(true);
      setSnackBarText("Jobseeker deleted successfully");

    }catch(ex){
      let error = ex.response ? ex.response.data.error : ex.message;
      setSnackbarSeverity("error");
      setSnackBarOpen(true);
      setSnackBarText(error);
    }finally{
      setDeleteId("");
    }
  }

  const handleAddClientInformation = (key, evt) => {
    setClientInformation({ ...clientInformation, [key]: evt.target.value });
  };

  const handleAddClient = () => {
    addClient({
      variables: {
        addJobSeekerFirstName: clientInformation.fName,
        addJobSeekerLastName: clientInformation.lName,
        addJobSeekerEmail: clientInformation.email.toLowerCase(),
        addJobSeekerPassword: clientInformation.password,
      },
    });
  };

  const handleOpenDelete = (id) => {
    setOpenDeleteDialog(true);
    setDeleteId(id);
  }

  const handleConfirmDelete = () => {
    setOpenDeleteDialog(false);
    handleDeleteJobseeker(deleteId);
  }

  return (
    <Card className="border shadow-sm">
      <Card.Body>
        <Grid driection="column">
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder="Search client by name, email and phone"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  style={{ width: "50rem" }}
                  inputProps={{ "aria-label": "search" }}
                  onChange={searchText}
                />
              </div>
            </Grid>
            <Grid item>
              <Grid container direction="row">
                <Grid item className="mr-10">
                  <Button
                    color="secondary"
                    className={`${classes.button} p-0`}
                    onClick={handleDialogOpenForAddClient}
                    startIcon={
                      <GroupAddOutlinedIcon style={{ fontSize: 25 }} />
                    }
                  >
                    <Typography className="" variant="h6">
                      Add Client
                    </Typography>
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    color="secondary"
                    className={`${classes.button} p-0`}
                    onClick={handleDialogOpen}
                    startIcon={
                      <InsertInvitationOutlinedIcon style={{ fontSize: 25 }} />
                    }
                  >
                    <Typography className="" variant="h6">
                      Invite Client to Join you
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Dialog
              open={DialogState}
              onClose={handleDialogClose}
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              fullWidth="100%"
              className="m-0"
            >
              <DialogTitle id="form-dialog-title" className="p-0">
                <header>
                  <Box
                    // className="d-flex justify-content-between"
                    style={{
                      background: "#F3F6F9",
                      padding: "30px 35px",
                      borderTopRightRadius: "5px",
                      borderTopLeftRadius: "5px",
                    }}
                  >
                    <Box className="d-flex flex-column text-black justify-content-start">
                      <h2
                        className="modal-title text-left text-uppercase font-weight-bold"
                        id="exampleModalLongTitle"
                      >
                        Invite Client
                      </h2>
                    </Box>
                  </Box>
                </header>
              </DialogTitle>
              <DialogContent
                style={{
                  padding: "30px 35px",
                }}
              >
                <Grid container direction="column" spacing={2}>
                  <Grid item>
                    <input
                      className="h-auto px-6 py-5 form-control form-control-solid"
                      autoFocus
                      style={{
                        background: "transparent",
                        border: "1px solid #CFD0D7",
                      }}
                      placeholder="First Name"
                      type="text"
                      onChange={handleFirstName}
                      required
                    />
                  </Grid>
                  <Grid item>
                    <input
                      className="h-auto px-6 py-5 form-control form-control-solid"
                      style={{
                        background: "transparent",
                        border: "1px solid #CFD0D7",
                      }}
                      id="lname"
                      placeholder="Last Name"
                      type="text"
                      onChange={handleLastName}
                      required
                    />
                  </Grid>
                  <Grid item>
                    <input
                      className="h-auto px-6 py-5 form-control form-control-solid"
                      style={{
                        background: "transparent",
                        border: "1px solid #CFD0D7",
                      }}
                      id="email"
                      placeholder="Email Address"
                      type="email"
                      onChange={handleEmail}
                      required
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              {/* <DialogActions>
                <Grid
                  className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                >
                  <Grid item>
                    <Button
                      size="large"
                      onClick={handleDialogClose}
                      variant={"contained"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      size="large"
                      onClick={handleSendInvitation}
                      color="secondary"
                      variant={"contained"}
                      className="px-10"
                      disabled={
                        firstName.length && lastName.length & email.length
                          ? false
                          : true
                      }
                    >
                      {sendInvitationLoader ? (
                        <CircularProgress
                          size="20px"
                          style={{
                            color: "#ffffff",
                            marginLeft: "9px",
                            marginRight: "9px",
                          }}
                          class=""
                        />
                      ) : (
                        <Typography style={{ width: "38px", height: "20px" }}>
                          Invite
                        </Typography>
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions> */}
              <DialogActions
                style={{
                  padding: "0px 35px 30px 35px",
                }}
              >
                <Box className="d-flex w-100" style={{ gap: "10px" }}>
                  <button
                    type="button"
                    onClick={handleSendInvitation}
                    className="btn btn-primary font-weight-bold px-9 w-50 py-4"
                    disabled={
                      firstName.length && lastName.length & email.length
                        ? false
                        : true
                    }
                  >
                    {sendInvitationLoader ? (
                      <CircularProgress
                        size="20px"
                        style={{
                          color: "#ffffff",
                          marginLeft: "9px",
                          marginRight: "9px",
                        }}
                        class=""
                      />
                    ) : (
                      <Typography>Invite</Typography>
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-light-primary font-weight-bold px-9 w-50 py-4"
                    onClick={handleDialogClose}
                    variant={"contained"}
                  >
                    Cancel
                  </button>
                </Box>
              </DialogActions>
            </Dialog>
          </Grid>
          <Grid item>
            <Dialog
              open={dialogStateForAddClient}
              onClose={handleDialogClose}
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              className="p-0 m-0"
              fullWidth="100%"
            >
              <DialogTitle id="form-dialog-title" className="p-0">
                <header>
                  <Box
                    // className="d-flex justify-content-between"
                    style={{
                      background: "#F3F6F9",
                      padding: "30px 35px",
                      borderTopRightRadius: "5px",
                      borderTopLeftRadius: "5px",
                    }}
                  >
                    <Box className="d-flex flex-column text-black justify-content-start">
                      <h2
                        className="modal-title text-left text-uppercase font-weight-bold"
                        id="exampleModalLongTitle"
                      >
                        Add Client
                      </h2>
                    </Box>
                  </Box>
                </header>
              </DialogTitle>
              <DialogContent
                style={{
                  padding: "30px 35px",
                }}
              >
                <Grid container direction="column" spacing={2}>
                  <Grid item>
                    <input
                      placeholder="First Name"
                      type="text"
                      style={{
                        background: "transparent",
                        border: "1px solid #CFD0D7",
                      }}
                      className="h-auto px-6 py-5 form-control form-control-solid"
                      onChange={(evt) => {
                        handleAddClientInformation("fName", evt);
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <input
                      placeholder="Last Name"
                      type="text"
                      style={{
                        background: "transparent",
                        border: "1px solid #CFD0D7",
                      }}
                      className="h-auto px-6 py-5 form-control form-control-solid "
                      onChange={(evt) => {
                        handleAddClientInformation("lName", evt);
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <input
                      placeholder="Email"
                      type="email"
                      style={{
                        background: "transparent",
                        border: "1px solid #CFD0D7",
                      }}
                      className="h-auto px-6 py-5 form-control form-control-solid "
                      onChange={(evt) => {
                        handleAddClientInformation("email", evt);
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <input
                      placeholder="Password"
                      type="password"
                      style={{
                        background: "transparent",
                        border: "1px solid #CFD0D7",
                      }}
                      className="h-auto px-6 py-5 form-control form-control-solid "
                      onChange={(evt) => {
                        handleAddClientInformation("password", evt);
                      }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions
                style={{
                  padding: "0px 35px 30px 35px",
                }}
              >
                <Box className="d-flex w-100" style={{ gap: "10px" }}>
                  <button
                    type="button"
                    onClick={handleAddClient}
                    className="btn btn-primary font-weight-bold px-9 py-4 w-50"
                    disabled={
                      clientInformation.fName.length &&
                      clientInformation.lName.length &&
                      clientInformation.email.length &&
                      clientInformation.password.length
                        ? false
                        : true
                    }
                  >
                    {addClientLoading ? (
                      <CircularProgress
                        size="20px"
                        style={{ color: "#ffffff" }}
                        className="mx-3"
                      />
                    ) : (
                      <Typography className="my-1">Submit</Typography>
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-light-primary font-weight-bold px-9 py-4 w-50"
                    onClick={handleDialogClose}
                  >
                    Cancel
                  </button>
                </Box>
              </DialogActions>
            </Dialog>
          </Grid>

          <Grid item>
            <Snackbar
              open={snackBarOpen}
              autoHideDuration={5000}
              color="danger"
              onClose={handleSnackBarClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Alert
                onClose={handleSnackBarClose}
                style={{ fontSize: "16px" }}
                severity={snackbarSeverity}
              >
                {snackBarText}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>

        <TableContainer className="mt-10 border">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headers.map((item, index) => (
                  <TableCell
                    key={index}
                    align="left"
                    classes={{ root: classes.tableHeadCell }}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <StyledTableRow
                  // hover={true}
                  // selected={true}
                  style={{ cursor: "pointer" }}
                  key={index}
                >
                  <TableCell
                    classes={{
                      root: `${classes.tableRowCell} text-capitalize`,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                    onClick={() => {
                      handleSelectedUser(row.id);
                    }}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                    onClick={() => {
                      handleSelectedUser(row.id);
                    }}
                  >
                    {row.email}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                    onClick={() => {
                      handleSelectedUser(row.id);
                    }}
                  >
                    {row.phone}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                    onClick={() => {
                      handleSelectedUser(row.id);
                    }}
                  >
                    <Typography class="text-capitalize align-middle">
                      {row.stage.replace(/([A-Z])/g, " $1").trim()}
                    </Typography>
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    <button
                    type="button"
                    onClick={()=>{handleOpenDelete(row.id)}}
                    className="btn btn-danger font-weight-bold px-9 py-4"
                  >
                    {row.id == deleteId ? (
                      <CircularProgress
                      size="20px"
                      style={{
                        color: "#ffffff",
                        marginLeft: "9px",
                        marginRight: "9px",
                      }}
                      class=""
                    />
                    ) : (
                      <Typography>Delete</Typography>
                    )}
                  </button>
                  </TableCell>
                  {/* <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    <Dropdown as={ButtonGroup}>
                      <Dropdown.Toggle id="dropdown-basic" className="border">
                        {" actions "}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          lineHeight: 0,
                          left: -100,
                          top: 40,
                        }}
                      >
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Block
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Unblock
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </TableCell>
                 */}
                </StyledTableRow>
              ))}
            </TableBody>

            <TablePagination
              count={count}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              />
          </Table>
        </TableContainer>

        <Dialog
        open={openDeleteDialog}
        onClose={()=>{setOpenDeleteDialog(false); setDeleteId("")}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete Jobseeker"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete it?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{setOpenDeleteDialog(false); setDeleteId("")}} color="primary">
            Cancle
          </Button>
          <Button onClick={handleConfirmDelete} color="#8b0000" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      </Card.Body>
    </Card>
    // </Box>
  );
}
